export default __webpack_public_path__ + "static/media/services11.42603690.jpg";